/**
 * A testid function generator to create consistently structured testids
 * @param componentIdentifier the type of component will this compound testid be used for ('header', 'input', 'cta', 'button')
 * @param prefix a unique prefix to differentiate instances of the same component when multiple are present in the same page
 * @returns string
 */
export const getCompoundTestIdGenerator = (componentIdentifier: string, prefix?: string) => {
  return (...testIds: string[]) =>
    (prefix ? [prefix, componentIdentifier, ...testIds] : [componentIdentifier, ...testIds]).join('-');
};
